(() => {
let diyAccessoryTrackCounter = 0;

class DiyAccessoryGroupNavigation {
  constructor(groupsElement) {
    this.groupsElement = groupsElement;
    this.resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver((entries) => {
          entries.forEach((entry) => this.updateTrack(entry.target));
        })
      : null;

    this.setupGroups();

    this.mutationObserver = new MutationObserver(() => {
      this.setupGroups();
      this.scheduleUpdate();
    });
    this.mutationObserver.observe(this.groupsElement, { childList: true, subtree: true });

    this.handleResize = () => this.scheduleUpdate();
    window.addEventListener('resize', this.handleResize, { passive: true });
    window.addEventListener('load', this.handleResize, { once: true });
  }

  setupGroups() {
    this.groupsElement.querySelectorAll('.diy-everything__group').forEach((group) => {
      const track = group.querySelector('.diy-everything__group-track');
      const title = group.querySelector('.diy-everything__group-title');
      if (!track || !title) return;

      let header = group.querySelector(':scope > .diy-everything__group-header');
      if (!header) {
        header = document.createElement('div');
        header.className = 'diy-everything__group-header';
        group.insertBefore(header, track);
        header.appendChild(title);
      }

      let navigation = header.querySelector('[data-diy-group-navigation]');
      if (!navigation) {
        navigation = this.createNavigation(title.textContent.trim() || 'accessories');
        header.appendChild(navigation);
      }

      if (!track.id) {
        diyAccessoryTrackCounter += 1;
        track.id = `DiyAccessoryTrack-${diyAccessoryTrackCounter}`;
      }
      navigation.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-controls', track.id);
      });

      if (track.dataset.diyGroupNavigationReady !== 'true') {
        track.dataset.diyGroupNavigationReady = 'true';
        track.addEventListener('scroll', () => this.scheduleTrackUpdate(track), { passive: true });
        navigation.addEventListener('click', (event) => {
          const button = event.target.closest('[data-diy-group-scroll]');
          if (!button || button.disabled) return;
          this.scrollTrack(track, button.dataset.diyGroupScroll === 'next' ? 1 : -1);
        });
        this.resizeObserver?.observe(track);
      }

      this.scheduleTrackUpdate(track);
    });
  }

  createNavigation(groupName) {
    const navigation = document.createElement('div');
    navigation.className = 'diy-everything__group-navigation';
    navigation.setAttribute('data-diy-group-navigation', '');
    navigation.innerHTML = `
      <button class="diy-everything__group-arrow" type="button" data-diy-group-scroll="previous" aria-label="Scroll ${this.escapeAttribute(groupName)} left">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5 8 12l7 7"/></svg>
      </button>
      <button class="diy-everything__group-arrow" type="button" data-diy-group-scroll="next" aria-label="Scroll ${this.escapeAttribute(groupName)} right">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg>
      </button>
    `;
    return navigation;
  }

  escapeAttribute(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('"', '&quot;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;');
  }

  scrollTrack(track, direction) {
    const firstCard = track.querySelector('.diy-everything-accessory');
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const cardWidth = firstCard?.getBoundingClientRect().width || track.clientWidth;
    const step = Math.max(1, cardWidth + gap);
    const visibleCards = Math.max(1, Math.floor((track.clientWidth + gap) / step));
    const distance = step * Math.max(1, visibleCards - 1);

    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  scheduleTrackUpdate(track) {
    if (track._diyNavigationFrame) return;
    track._diyNavigationFrame = window.requestAnimationFrame(() => {
      track._diyNavigationFrame = null;
      this.updateTrack(track);
    });
  }

  scheduleUpdate() {
    if (this.updateFrame) return;
    this.updateFrame = window.requestAnimationFrame(() => {
      this.updateFrame = null;
      this.groupsElement.querySelectorAll('.diy-everything__group-track').forEach((track) => this.updateTrack(track));
    });
  }

  updateTrack(track) {
    const group = track.closest('.diy-everything__group');
    const navigation = group?.querySelector('[data-diy-group-navigation]');
    if (!navigation) return;

    const previousButton = navigation.querySelector('[data-diy-group-scroll="previous"]');
    const nextButton = navigation.querySelector('[data-diy-group-scroll="next"]');
    const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
    const hasOverflow = maxScrollLeft > 2;

    navigation.hidden = !hasOverflow;
    previousButton.disabled = !hasOverflow || track.scrollLeft <= 2;
    nextButton.disabled = !hasOverflow || track.scrollLeft >= maxScrollLeft - 2;
  }
}

function initDiyAccessoryGroupNavigation(scope = document) {
  scope.querySelectorAll('.diy-everything__groups').forEach((groupsElement) => {
    if (groupsElement.dataset.diyGroupNavigationInitialized === 'true') return;
    groupsElement.dataset.diyGroupNavigationInitialized = 'true';
    groupsElement._diyGroupNavigation = new DiyAccessoryGroupNavigation(groupsElement);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initDiyAccessoryGroupNavigation());
} else {
  initDiyAccessoryGroupNavigation();
}

document.addEventListener('shopify:section:load', (event) => initDiyAccessoryGroupNavigation(event.target));
})();
